<template>
  <div class="brand-image">
    <!--      Card brand. Can be amex, diners, discover, jcb, mastercard, unionpay, visa, or unknown.-->
    <template v-if="brand === 'visa'">
      <img
        src="../../../assets/img/account/plan/card-brand/visa.svg"
        alt=""
      >
    </template>
    <template v-if="brand === 'mastercard'">
      <img
        src="../../../assets/img/account/plan/card-brand/mastercard.svg"
        alt=""
      >
    </template>
    <template v-if="brand === 'mir'">
      <img
        src="../../../assets/img/account/plan/card-brand/mir-logo.svg"
        alt=""
      >
    </template>
    <template v-if="brand === 'amex'">
      <img
        src="../../../assets/img/account/plan/card-brand/amex.svg"
        alt=""
      >
    </template>
    <template v-if="brand === 'diners'" />
    <template v-if="brand === 'discover'" />
    <template v-if="brand === 'jcb'">
      <img
        src="../../../assets/img/account/plan/card-brand/jcb.svg"
        alt=""
      >
    </template>
    <template v-if="brand === 'unionpay'" >
      <img
        src="../../../assets/img/account/plan/card-brand/unionpay.svg"
        alt=""
      >
    </template>
  </div>
</template>

<script>
export default {
  name: 'PaymentMethodCardBrand',
  props: {
    brand: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .brand-image {
    line-height: 0;
    img {
      max-width: 100%;
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .brand-image-wrap {
      max-width: 2rem;
    }
  }
</style>
